<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix header">
      <el-avatar icon="el-icon-user-solid" style="float: left; margin-right: 10px; height: 100%"></el-avatar>
      <span>{{ user.title }}</span>
      <span class="subheader">{{ lists.userTypes.find((t) => t.id == user.id_user_types).title }}</span>
    </div>
    <div v-if="client" class="client clearfix">
      <div class="row">
        <div class="title">Клиент</div>
        <div class="description">{{ client.title }}</div>
      </div>
      <div class="row">
        <div class="title">ИНН</div>
        <div class="description">{{ client.inn }}</div>
      </div>
      <div class="row">
        <div class="title">НДС</div>
        <div class="description">
          {{ lists.vat.find((v) => v.id == client.vat).title }}
        </div>
      </div>
      <div class="row">
        <div class="title">СНО</div>
        <div class="description">{{ lists.sno.find((s) => s.id == client.sno).title }}</div>
      </div>
      <div class="row">
        <div class="title">Сайт</div>
        <div class="description">
          <a :href="client.payment_address" target="_blank">{{ client.payment_address }}</a>
        </div>
      </div>
      <div class="row">
        <div class="title">Телефон</div>
        <div class="description">{{ client.phone }}</div>
      </div>
      <div class="row">
        <div class="title">Email</div>
        <div class="description">
          <a :href="'mailto:' + client.email" target="_blank">{{ client.email }}</a>
        </div>
      </div>
      <div class="row">
        <div class="title">Лимит</div>
        <div class="description">{{ client.max_tickets }} билетов за раз</div>
      </div>
    </div>
  </el-card>
</template>

<script>
import jwtDecode from "jwt-decode";
import { mapState } from "vuex";

export default {
  data: () => ({
    user: null,
    client: null,
  }),
  computed: {
    ...mapState(["lists"]),
  },
  async created() {
    const token = window.localStorage.getItem("token");
    if (token) {
      this.user = jwtDecode(token);
    }
    try {
      const client = await this.$axios.get(`/api/clients/${this.user.id_clients}`);
      this.client = client.data.data.client;
    } catch (e) {
      console.log(e);
    }
  },
};
</script>
